export default {"src":"/_next/static/media/left-arrow-white-circle.317f86b0.svg","height":39,"width":38,"blurWidth":0,"blurHeight":0};